import { j as g } from "./jsx-runtime-3tyXYecC.mjs";
import { f as t } from "./index-LyFokDcn.mjs";
import { m as s } from "./tss-DN0acMKN.mjs";
import { g as f } from "./get-encore-value-Di648HqV.mjs";
import { u } from "./use-svg-DBlH3_L4.mjs";
const w = s()(({ constructs: e }, i) => {
  const { color: n, height: o, maxHeight: r, maxWidth: a, minHeight: m, minWidth: d, width: l } = i;
  return {
    root: {
      fill: t.ifFeature(
        "encore",
        f(n, {
          /* eslint-disable sort-keys */
          "bamboo-brand-medium": e.icon.bambooBrand.medium,
          "discovery-weak": e.icon.discovery.weak,
          "discovery-medium": e.icon.discovery.medium,
          "discovery-strong": e.icon.discovery.strong,
          "error-weak": e.icon.error.weak,
          "error-medium": e.icon.error.medium,
          "error-strong": e.icon.error.strong,
          "info-weak": e.icon.info.weak,
          "info-medium": e.icon.info.medium,
          "info-strong": e.icon.info.strong,
          link: e.icon.link.idle,
          "neutral-extra-weak": e.icon.neutral.xWeak,
          "neutral-weak": e.icon.neutral.weak,
          "neutral-medium": e.icon.neutral.medium,
          "neutral-strong": e.icon.neutral.strong,
          "neutral-extra-strong": e.icon.neutral.xStrong,
          "neutral-extra-extra-strong": e.icon.neutral.xxStrong,
          "neutral-forced-white": e.icon.neutral.inverted,
          "neutral-inverted": e.icon.neutral.inverted,
          "notice-strong": e.icon.notice.strong,
          "primary-medium": e.icon.primary.medium,
          "primary-strong": e.icon.primary.strong,
          "success-weak": e.icon.success.weak,
          "success-medium": e.icon.success.medium,
          "success-strong": e.icon.success.strong,
          "warning-weak": e.icon.warning.weak,
          "warning-medium": e.icon.warning.medium,
          "warning-strong": e.icon.warning.strong
          /* eslint-enable sort-keys */
        })
      ),
      flexShrink: 0,
      height: o,
      maxHeight: r,
      maxWidth: a,
      minHeight: m,
      minWidth: d,
      width: l
    }
  };
});
function h(e) {
  const { ariaLabel: i, color: n, image: o } = e, { classes: r } = w(e), a = `https://staticfe.bamboohr.com/assets/images/${o}.svg`, m = u(a);
  return n !== void 0 ? /* @__PURE__ */ g.jsx("svg", { "aria-label": i, className: r.root, "data-fabric-component": "Svg", ...m }) : /* @__PURE__ */ g.jsx("img", { alt: i, className: r.root, "data-fabric-component": "Svg", src: a });
}
export {
  h as S
};
//# sourceMappingURL=svg-BVTPQfIY.mjs.map
